import React from 'react';
import { Link } from 'react-router-dom';
import { featuredSlugs, services } from '../data/serviceCatalog';
import { ArrowRight } from 'lucide-react';

export const FeaturedServices = () => (
  <section className="py-20 bg-white" data-testid="featured-services-section">
    <div className="container mx-auto px-4">
      <div className="text-center mb-10">
        <span className="inline-block bg-[#0A2463]/5 text-[#0A2463] px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider">Popular Services</span>
        <h2 className="text-3xl md:text-4xl font-black text-[#0A2463] mt-3">Business Services Our Clients Trust</h2>
        <p className="text-gray-500 mt-2 text-sm md:text-base">The most-requested registrations, certifications and compliance services.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-7xl mx-auto">
        {featuredSlugs.map((slug) => {
          const s = services[slug]; if (!s) return null;
          return (
            <Link key={slug} to={`/services/${slug}`} data-testid={`featured-${slug}`}
              className="group bg-white rounded-2xl border border-gray-100 hover:border-[#0A2463]/20 shadow-sm hover:shadow-2xl transition-all hover:-translate-y-1 overflow-hidden">
              <div className="relative h-32 overflow-hidden">
                <img src={s.image} alt={s.imageAlt} loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A2463]/60 to-transparent" />
                <div className="absolute bottom-2 left-3 text-white text-[10px] font-bold uppercase tracking-wider">{s.timeline}</div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-[#0A2463] leading-tight line-clamp-2 min-h-[36px]">{s.title}</h3>
                <p className="text-xs text-gray-500 mt-1.5 line-clamp-2">{s.short}</p>
                <div className="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
                  <span className="text-[11px] font-bold text-[#FB8500]">{s.price}</span>
                  <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#0A2463] group-hover:gap-2 transition-all">
                    Learn more <ArrowRight size={11} />
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);

export default FeaturedServices;
